var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSanity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_571_22266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.24219 9.21562C8.86929 8.96547 8.52068 8.68089 8.20094 8.36563C7.05969 7.22813 6.47594 5.78188 6.47594 3.90563V3.18687C8.37344 1.23937 11.2984 0.078125 14.7847 0.078125C21.5272 0.078125 25.4284 3.57812 26.3909 8.50312H20.2747C19.5997 6.56062 17.9122 5.04813 14.8347 5.04813C11.8072 5.04813 9.66469 6.64312 9.24344 9.21562H9.24219ZM5.85344 3.90563C5.85344 7.95062 8.39594 10.3581 13.4859 11.6269L18.8809 12.8556C23.6984 13.9431 26.6309 16.6431 26.6309 21.0431C26.667 22.9644 26.0322 24.8381 24.8359 26.3419C24.8359 21.9531 22.5234 19.5806 16.9484 18.1544L11.6534 16.9719C7.41219 16.0219 4.13969 13.8019 4.13969 9.02188C4.11884 7.17239 4.72342 5.36989 5.85344 3.90563ZM21.4747 20.6831C21.1097 23.4769 18.8597 25.0519 15.6022 25.0519C12.7097 25.0519 10.5422 23.8694 9.72344 21.3144H3.36719C4.39719 26.8781 9.02969 30.0781 15.6484 30.0781C19.1834 30.0781 22.2447 28.9906 24.2109 27.0294V26.3419C24.2109 24.2669 23.6697 22.7469 22.5334 21.5719C22.2112 21.2413 21.8565 20.944 21.4747 20.6844V20.6831Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_571_22266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0 0.078125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSanity);
export default __webpack_public_path__ + "static/media/sanity.a9d15fde608de85341fd6bb8a75a7507.svg";
export { ForwardRef as ReactComponent };